export default __webpack_public_path__ + "static/media/a-boy-and-his-kite.80eb3db9.jpg";